/**
 * Created by Ko-Hsin on 16/05/2018.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { style, state, animate, transition, trigger} from "@angular/animations";

@Component({
    selector: 'alert-panel',
    animations: [
        trigger('slider', [
            state('expand', style({ height: '*' })),
            state('collapse, void', style({ height: '0', padding:0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])],
    template: `
        <div class="alert_panel" [@slider]="alertState">
            <div class="wrap">{{alert_message}}</div>
        </div>
    `,
    styles: [`
        .alert_panel { background:#fff; height: 80px; padding:0 10px 10px; color:#fff; font-family: "ff-netto-web",sans-serif;
            font-size:28px; overflow:hidden; }
        .alert_panel .wrap { background:#00EE99; line-height: 70px; border-radius: 5px 5px 0 5px; text-align: center; }

    `]
})
export class AlertPanelComponent {
    _alert_message = '';
    _alertState = true;

    get alertState() {
        return this._alertState ? 'collapse' : 'expand';
    }
    @Input('message')
    get alert_message() {
        return this._alert_message;
    }
    set alert_message(msg) {
        this._alert_message = msg;
        if (this._alert_message) {
            this._alertState = false;
            setTimeout( () => {
                this._alert_message = '';
                this.messageChange.emit('');
            }, 4000 );
            setTimeout( () => this._alertState = true, 3000);
        }
    }
    @Output() messageChange: EventEmitter<string> = new EventEmitter<string>();
}


// WEBPACK FOOTER //
// ./src/app/shared/alert-panel.ts